import { getFetch } from '../fetch';
import { apiConfig } from '../config';
// @ts-ignore
import { SUBJECTS_SLUGS } from '../../../constants';
import { CalendarPlan, CalendarPlanThemeLink } from '../../../typings';

interface RequestData {
    grade: number;
    subject: SUBJECTS_SLUGS;
}

export interface CalendarPlanWithThemes extends CalendarPlan {
    themes_with_periods: CalendarPlanThemeLink[];
}

export function getCalendarPlanWithThemes(requestData: RequestData): Promise<CalendarPlanWithThemes> {
    const { apiGetCalendarPlanWithThemes } = apiConfig.getStaticUrls();

    return getFetch(apiGetCalendarPlanWithThemes, requestData);
}
